import { BookingExpiry } from './booking_expiry';

export default BookingExpiry;
